import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '../../../../business-services/customer.service';
import { CustomerCallHistoryRequestModel } from '../../../../business-entities/customer-call-history';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-customer-call-history',
  templateUrl: './customer-call-history.component.html',
  styleUrls: ['./customer-call-history.component.css']
})

export class CustomerCallHistoryComponent implements OnInit, OnDestroy {
  //#region Declaration
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  lstCallHistory: any[];
  callRequestModel: CustomerCallHistoryRequestModel = {
    CustomerMobile: '',
    CultureCode: '',
    StartRecordNo: 0,
    NoOfRecord: 25,
    SortColumn: 'CallStartTime',
    SortDirection: 'DESC'
  };
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  callDetail: any;
  //#endregion

  //#region Constructor & Init
  constructor(private customerService: CustomerService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.lstCallHistory = [];
    this.callRequestModel.CustomerMobile = this.customerService.customerDetail.mobileNo;
    this.GetCallHistoryList();
  }
  ngOnDestroy(): void {
    this.callRequestModel = null;
    this.lstCallHistory = [];
    this.totalCount = 0;
  }
  //#endregion

  //#region Page Method
  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.callRequestModel.SortColumn = column;
    this.callRequestModel.SortDirection = direction;
    this.callRequestModel.StartRecordNo = 0;
    this.lstCallHistory = [];
    this.totalCount = 0;
    await this.GetCallHistoryList();
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.lstCallHistory.length){
      this.callRequestModel.StartRecordNo = this.lstCallHistory.length;
      this.GetCallHistoryList();
    }
  }
  OnClose() {
    this.activeModal.close({ success: false });
  }
  ViewDetails(viewDetailContent, call){
    this.callDetail = call;
    let modalRef = this.modalService.open(viewDetailContent, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    modalRef.result.then(() => {
      this.callDetail = null;
    });
  }
  getLocalDate(date){
    return Utility.ConvertUTCDateToLocalDate(date);
  }
  getTimeDuration(startDate: any, endDate: any){
    return Utility.GetTimeDuration(startDate, endDate);
  }
  //#endregion

  //#region API Method
  async GetCallHistoryList() {
    this.spinner.show();
    await this.customerService.GetCallHistoryList(this.callRequestModel).then((res) => {
      if (res.responseObject?.length > 0) {
        this.lstCallHistory.push(...res.responseObject);
        this.totalCount = this.lstCallHistory[0].totalCount;
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }
  //#endregion
}
